/**
 * @generated SignedSource<<b7cc9a5d2dc8b0115beda559e5c4dddc>>
 * @relayHash 15584b4ffbb9bcbfacd03a809013825a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4a56529c04288388a8109710e43db61d8e7771f7bf2397ed3b08fbaf32a92504

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsEmbeddedWidgetsAppQuery$variables = {
  helpCenterAri: string;
  skip: boolean;
};
export type HelpCenterSettingsEmbeddedWidgetsAppQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri?: {
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"EmbeddedWidgets_AtlassianCsmWidgetConfiguration_EmbeddedWidgets">;
  } | null;
};
export type HelpCenterSettingsEmbeddedWidgetsAppQuery = {
  response: HelpCenterSettingsEmbeddedWidgetsAppQuery$data;
  variables: HelpCenterSettingsEmbeddedWidgetsAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "csmAi_getAiHubByHelpCenterAri",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "EmbeddedWidgets_AtlassianCsmWidgetConfiguration_EmbeddedWidgets"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "csmAi_getAiHubByHelpCenterAri",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "agentId"
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "versionType",
                                "value": "LIVE"
                              }
                            ],
                            "concreteType": "CsmAiAgentVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CsmAiAgentVersion",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "versions(versionType:\"LIVE\")"
                          }
                        ],
                        "type": "CsmAiMultiVersionAgent"
                      }
                    ]
                  },
                  (v3/*: any*/),
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EMBED"
                      }
                    ],
                    "kind": "LinkedField",
                    "name": "widgets",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                          }
                        ],
                        "type": "CsmAiWidgetConfig"
                      }
                    ],
                    "storageKey": "widgets(type:\"EMBED\")"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ],
                "type": "CsmAiHub"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4a56529c04288388a8109710e43db61d8e7771f7bf2397ed3b08fbaf32a92504",
    "metadata": {},
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e257ef6ced6782cdc5424180f1b7874f";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
